import Vue from 'vue';
Vue.mixin({
    computed: {
    },
    methods: {
        // 全局方法，用于检查权限
        hasPermission(permission) {
            const userPermissions = this.$store.state.role
            return userPermissions.includes(permission);
        }
    }
});
